module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-fa-pc"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('div', {
    staticClass: "sologan"
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-fa-case-list"
  }, [_c('img', {
    staticClass: "case-title",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_title_industry.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "case-category"
  }, _vm._l((_vm.all_industry_data_list), function(cat, index) {
    return _c('div', {
      staticClass: "cat-item",
      class: {
        'cat-item-active': _vm.current_industry_list.id == cat.id
      },
      on: {
        "click": function($event) {
          _vm.onClickChangeActiveIndustry(index)
        }
      }
    }, [_vm._v(_vm._s(cat.name))])
  })), _vm._v(" "), _c('ul', {
    staticClass: "case-wrap"
  }, [_vm._l((_vm.current_industry_list.case_list), function(item) {
    return _c('li', {
      staticClass: "case-item"
    }, [_c('div', {
      staticClass: "cover"
    }, [_c('div', {
      staticClass: "cover-title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "cover-intro"
    }, [_vm._v(" " + _vm._s(item.brief) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "cover-round"
    }, [_vm._v(" " + _vm._s(item.round) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "cover-content"
    }, [_c('p', [_vm._v(_vm._s(item.vc))])])]), _vm._v(" "), _c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.logo
      }
    })])
  }), _vm._v(" "), _vm._l((10), function(item) {
    return (false) ? _c('li', {
      staticClass: "case-item"
    }, [_vm._m(1, true, false), _vm._v(" "), _c('img', {
      staticClass: "logo",
      attrs: {
        "src": require("../../assets/img2/pc/chuangfu/logo10.png"),
        "alt": ""
      }
    })]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fzg-industry-research"
  }, [_c('img', {
    staticClass: "industry-title",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_title_research.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fzg-industry-wrap"
  }, [_c('div', {
    staticClass: "industry-left"
  }, [_c('a', {
    attrs: {
      "href": _vm.first_industry_research.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa-research-bg-1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-title"
  }, [_vm._v(" " + _vm._s(_vm.first_industry_research.title))])])]), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fa-data"
  }, [_c('img', {
    staticClass: "fa-data-title",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_title_fa.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fa-data-intro"
  }, [_c('p', [_vm._v("凡卓资本已帮助超过"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("600家")]), _vm._v("创业公司获得超"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("800亿")]), _vm._v("元融资额。近两年内帮助数百个明星项目完成近"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("300亿")]), _vm._v("元融资。明星项目包括欣旺达EVB、东方空间、神策数据、雪浪云、瀚博半导体等。")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-data-list"
  }, [_c('div', {
    staticClass: "fa-data-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_data_1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          帮助超过"), _c('br'), _vm._v("\n          600家创业公司完成融资\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-data-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_data_2.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          累计帮助创业公司获得"), _c('br'), _vm._v("\n          超过800亿元融资额\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-data-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_data_3.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n          2年内协助上百个明星项目"), _c('br'), _vm._v("\n          获得超过300亿人民币融资\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-title"
  }, [_vm._v(" 保碧新能源 ")]), _vm._v(" "), _c('div', {
    staticClass: "cover-intro"
  }, [_vm._v(" 保利资本和碧桂园创投联合孵化的综合能源管理服务商 ")]), _vm._v(" "), _c('div', {
    staticClass: "cover-round"
  }, [_vm._v(" 天使轮 ")]), _vm._v(" "), _c('div', {
    staticClass: "cover-content"
  }, [_vm._v("\n            华美国际集团"), _c('br'), _vm._v("\n            蔚来资本"), _c('br'), _vm._v("\n            钟鼎资本"), _c('br'), _vm._v("\n            星航资本"), _c('br'), _vm._v("\n            凡卓资本"), _c('br'), _vm._v("\n            上海易连"), _c('br'), _vm._v("\n            保利资本"), _c('br'), _vm._v("\n            碧桂园创投"), _c('br'), _vm._v("\n            多家光伏产业链头部上市公司\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "industry-right"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2461518903014227974&scene=173&from_msgid=2653828008&from_itemidx=1&count=3&nolastread=1#wechat_redirect"
    }
  }, [_c('div', {
    staticClass: "right-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa-research-bg-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "r-item-title"
  }, [_vm._v("产业研究")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=1332425999589670913&scene=126#wechat_redirect"
    }
  }, [_c('div', {
    staticClass: "right-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa-research-bg-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "r-item-title"
  }, [_vm._v("  行业研究")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2646833031260979201&scene=126#wechat_redirect"
    }
  }, [_c('div', {
    staticClass: "right-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa-research-bg-4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "r-item-title"
  }, [_vm._v("区域经济研究")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf7559b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fa/FzgFaPc.vue
// module id = 241
// module chunks = 0